import { getCurrentOrg } from "#webapp/src/util/org.util";
import { ApolloError, useQuery } from "@apollo/client";
import { getValue } from "@clockwise/client-commons/src/util/errorable.util";
import { getDefaultInviteSuggestions } from "../utils/getDefaultInviteSuggestions";
import { InviteSuggestionsDocument } from "./__generated__/InviteSuggestions.generated";

export const useInviteSuggestions = (onError?: (error: ApolloError) => void) => {
  const { data, loading } = useQuery(InviteSuggestionsDocument, {
    fetchPolicy: "no-cache", // needed to refetch suggestions when user goes back in onboarding
    onError: (error) => {
      if (!!onError) {
        onError(error);
      }
    },
  });
  const currentOrg = getCurrentOrg(data?.viewer);

  const suggestedInvites = getValue(currentOrg?.suggestedInvites)?.edges ?? [];
  const defaultSearchPersons =
    getValue(currentOrg?.orgPersonListPaginatedErrorable)?.searchPersons || null;

  const defaultSuggestions = getDefaultInviteSuggestions(suggestedInvites, defaultSearchPersons);

  return { suggestions: defaultSuggestions, loading };
};
